<template>
  <div class="sw-wrapper">
    <!-- Sidebar -->
    <side-bar class="sw-sidebar" />
    <section class="w-100">
      <navbar-dashboard name=""></navbar-dashboard>
      <div class="ew-view" v-if="!isLoading">
        <div class="ew-form-page">
          <page-header title="Pagar envío" subtitle="Revisa los datos y elige cómo pagar tu guía."></page-header>

          <div class="ew-section">
            <div class="ew-pay-service">
              <img v-if="shipment.selected_service.carrier_logo_url_svg" :src="shipment.selected_service.carrier_logo_url_svg"
                alt="" height="32">
              <div>
                <div class="ew-pay-service-name">{{ shipment.selected_service.carrier | carrierName }}</div>
                <div class="text-muted small">{{ shipment.selected_service.carrier_service_name | serviceName }}</div>
              </div>
              <div class="ml-auto text-right">
                <div class="text-muted small">Total a pagar</div>
                <div class="ew-pay-total">{{ shipment.selected_service.total_amount | money(shipment.selected_service.currency || 'MXN') }}</div>
              </div>
            </div>

            <dl class="ew-pay-details">
              <dt>Origen</dt>
              <dd>{{ [shipment.origin_direction.full_name, shipment.origin_direction.address, shipment.origin_direction.city].filter(Boolean).join(', ') }}</dd>
              <dt>Destino</dt>
              <dd>{{ [shipment.destination_direction.full_name, shipment.destination_direction.address, shipment.destination_direction.city].filter(Boolean).join(', ') }}</dd>
              <template v-if="shipment.parcels && shipment.parcels.length">
                <dt>Paquete</dt>
                <dd>{{ shipment.parcels[0].depth }} × {{ shipment.parcels[0].width }} × {{ shipment.parcels[0].height }} cm · {{ shipment.parcels[0].weight }} kg</dd>
              </template>
            </dl>
          </div>

          <div class="ew-section">
            <h2 class="ew-section-title"><i class="bi bi-shield-lock text-primary"></i> Método de pago</h2>
            <p class="ew-section-subtitle">Tus datos de pago se procesan de forma segura.</p>

            <div class="ew-pay-methods" role="radiogroup" aria-label="Método de pago">
              <button type="button" class="ew-pay-method" :class="{ 'is-active': paymentMethod === 'paypal' }"
                role="radio" :aria-checked="paymentMethod === 'paypal'" @click="paymentMethod = 'paypal'">
                <i class="bi bi-credit-card"></i>
                <span><strong>Tarjeta o PayPal</strong><small>Pago en línea</small></span>
              </button>
              <button type="button" class="ew-pay-method" :class="{ 'is-active': paymentMethod === 'wallet' }"
                role="radio" :aria-checked="paymentMethod === 'wallet'" @click="paymentMethod = 'wallet'">
                <i class="bi bi-wallet2"></i>
                <span><strong>Monedero</strong><small>Disponible: {{ total_monedero | money }}</small></span>
              </button>
            </div>

            <div v-if="paymentMethod === 'paypal'" class="mt-3">
              <div id="paypal-button-container"></div>
              <p class="text-muted small text-center mt-2 mb-0"><i class="bi bi-lock mr-1"></i>Pago seguro con PayPal</p>
            </div>

            <div v-if="paymentMethod === 'wallet'" class="ew-form-actions mt-3">
              <button class="btn btn-primary" v-on:click="paymentMonedero">
                <i class="bi bi-wallet2 mr-1"></i> Pagar con monedero
              </button>
            </div>

            <div v-if="isPaymentGuide" class="alert alert-warning mt-3 mb-0">
              <strong>No hay guías disponibles.</strong> Este servicio no tiene guías disponibles en este momento. Elige otro servicio o inténtalo más tarde.
            </div>
          </div>
        </div>
      </div>

      <div v-else class="ew-view">
        <div class="ew-form-page">
          <span class="ew-skeleton mb-3" style="width: 200px; height: 1.6rem;"></span>
          <div class="ew-section"><span class="ew-skeleton mb-2"></span><span class="ew-skeleton" style="width: 60%;"></span></div>
          <div class="ew-section"><span class="ew-skeleton mb-2"></span><span class="ew-skeleton" style="width: 40%;"></span></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import commons from '../commons'
import Sidebar from './Sidebar'
import Navbar from './Header/Navbar';

export default {
  name: 'PaymentDetails',
  data() {
    return {
      paymentMethod: '', // paypal, card, wallet
      shipmentId: null,
      shipment: null,
      isLoading: true,
      isPaymentGuide: false,
      payDisabled: false,
      total_monedero: 0,
    }
  },
  created() {
    this.getUser();
    console.log(this.user)
    this.shipmentId = this.$route.params.id
    this.getPrepaidsUser()
    this.getShipment(this.shipmentId)
      .then(response => {
        this.shipment = response.data
        axios.post(`${commons.apiURL}/api/v1/payments/${this.shipmentId}?email=${this.user.email}`)
          .then(response => {
            if (response.status === 204) {
              this.isPaymentGuide = true;
            } else {
              this.paypalLink = response.data.url
            }
          })
        this.isLoading = false
      })
      .catch(error => {
        console.error(error)
      })
  },
  watch: {
    paymentMethod(newVal) {
      if (newVal === 'paypal') {
        this.$nextTick(() => {
          this.initPaypalPayment();
        });
      }
    }
  },
  methods: {
    getPrepaidsUser() {
      this.total_monedero = 0
      this.monederoDisabled = true
      axios
        .get(`${commons.apiURL}/api/v1/prepaid?user=${localStorage.getItem('ew-user-id')}`)
        .then(response => {
          let prepaids = response.data
          for (var i = 0; i < prepaids.length; i++) {
            if (prepaids[i].status == true) {
              this.total_monedero += parseFloat(prepaids[i].amount);
            }
          }
          this.total_monedero = this.total_monedero.toFixed(2);
          this.monederoDisabled = this.total_monedero < this.total;
          console.log("monedero: " + this.total)
          console.log("monedero: " + this.monederoDisabled)
        })
        .catch(error => {
          console.error(error)
        })

    },
    formatCurrency(value) {
      return Number(value).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    },
    getShipment(id) {
      const url = `${commons.apiURL}/api/v1/shipments/${id}`
      return axios.get(url)
    },
    initPaypalPayment() {
      try {
        // Verificar si el SDK de PayPal está cargado
        if (!window.paypal) {
          console.error("El SDK de PayPal aún no se ha cargado.");
          return;
        }
        console.log("El SDK de PayPal aún se ha cargado.");

        // Verificar si el contenedor existe
        const container = document.getElementById("paypal-button-container");
        if (!container) {
          console.error("El contenedor #paypal-button-container no existe en el DOM.");
          return;
        }
        console.log("El contenedor #paypal-button-container existe en el DOM.");

        // Limpiar el contenedor antes de renderizar el botón
        container.innerHTML = "";

        window.paypal
          .Buttons({
            createOrder: async () => {
              try {
                document.querySelectorAll("button.btn-outline-secondary").forEach((elem) => {
                  elem.disabled = true;
                });

                const response = await fetch(
                  `${commons.apiURL}/api/v1/paypal/v2/link/many`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      shipments: this.shipments,
                    }),
                  }
                );

                const orderData = await response.json();

                if (orderData.id) {
                  return orderData.id;
                } else {
                  console.log(orderData);
                  const errorDetail = orderData.details[0];
                  const errorMessage = errorDetail
                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                    : JSON.stringify(orderData);

                  throw new Error(errorMessage);
                }
              } catch (error) {
                this.enablePaymentOptions();
                console.log(`Could not initiate PayPal Checkout...<br><br>${error}`);
              }
            },
            onApprove: async (data, actions) => {
              try {
                const response = await fetch(
                  `${commons.apiURL}/api/v1/paypal/v2/capture-order/${data.orderID}`,
                  {
                    method: "GET",
                  }
                );

                const orderData = await response.json();
                if (orderData.status) {
                  api.shipment
                    .generateGuidesAfterPayMany(this.user.email, this.user, this.shipments)
                    .then((response) => {
                      let data = response.data;
                      if (data.execute) {
                        if (this.isRecoleccionLocal) {
                          this.createRecoleccion();
                        }
                        this.$router.push({
                          path: `/payments/result/success?home=true&email=${this.user.email}`,
                        });
                      } else {
                        this.$router.push({ path: "/payments/result/error" });
                      }
                    })
                    .catch(() => {
                      this.$router.push({ path: "/payments/result/error" });
                    });
                  return;
                }
                if (!orderData.details) {
                  throw new Error(JSON.stringify(orderData));
                }
                const errorDetail = orderData.details[0];

                if (errorDetail.issue === "INSTRUMENT_DECLINED") {
                  return actions.restart();
                } else if (errorDetail) {
                  throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
                } else if (!orderData.purchase_units) {
                  throw new Error(JSON.stringify(orderData));
                }
              } catch (error) {
                console.log(`Sorry, your transaction could not be processed...<br><br>${error}`);
                this.$router.push({ path: "/payments/result/error" });
              }
            },
            onCancel: () => {
              this.enablePaymentOptions();
              console.log("Cancel");
            },
            onError: (err) => {
              this.enablePaymentOptions();
              console.log(err);
              this.$router.push({ path: "/payments/result/error" });
            },
          })
          .render("#paypal-button-container");
      } catch (error) {
        console.log(`Sorry, ${error}`);
      }
    },
    async paymentMonedero() {
      this.isLoadingPage = true;
      try {
        if (this.paymentMethod !== "wallet" || this.monederoDisabled) return;
        this.monederoDisabled = true;
        const response = await axios.post(`${commons.apiURL}/api/v1/payments/many/monedero`, {
          email: this.user.email,
          user: localStorage.getItem('ew-user-id'),
          shipments: this.shipments
        });

        if (response.data.message === "ok") {
          this.$router.push({
            path: "/payments/result/success",
            query: { monedero: "true", email: this.user.email }
          });
        } else {
          this.$router.push({
            path: "/payments/result/error",
            query: { monedero: "false", message: response.data.message, error: response.data.error }
          });
        }
      } catch (error) {
        console.error("Error en pago con monedero:", error);
      } finally {
        this.isLoadingPage = false;
      }
    },
    ...mapActions(['getUser'])
  },
  computed: {
    ...mapGetters(['user'])
  },
  components: {
    'side-bar': Sidebar,
    'navbar-dashboard': Navbar
  },
  mounted() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/variables";

.sw-wrapper {
  display: flex;
  min-height: 100vh;
  width: 100%;
}

.h3 {

  font-weight: 600;
}

.ew-smaller-container {
  max-width: 450px;
}

.ew-custom-control {
  border: 1px solid $gray-400;
  border-radius: $border-radius-lg;
  margin-bottom: 1rem;
  padding: 1rem;

  label {
    display: block;
  }
}

.ew-navbar {
  .btn {
    font-size: 1.5rem;
  }
}

.ew-mb {
  margin-bottom: 5rem;
}
</style>

<style scoped>
.ew-pay-service {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eceef5;
}

.ew-pay-service-name {
  color: #1c2030;
  font-weight: 700;
}

.ew-pay-total {
  color: #1c2030;
  font-size: 1.35rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.ew-pay-details {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: 8px 20px;
  margin: 16px 0 0;
  font-size: 0.875rem;
}

.ew-pay-details dt {
  color: #6b7185;
  font-weight: 500;
}

.ew-pay-details dd {
  margin: 0;
  color: #2f3446;
}

.ew-pay-methods {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.ew-pay-method {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #dfe2ec;
  border-radius: 10px !important;
  background: #fff;
  color: #2f3446;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ew-pay-method i {
  color: #6b7185;
  font-size: 1.3rem;
}

.ew-pay-method span {
  display: flex;
  flex-direction: column;
}

.ew-pay-method small {
  color: #6b7185;
}

.ew-pay-method:hover {
  border-color: #9aa0b1;
}

.ew-pay-method.is-active {
  border-color: #031d7d;
  box-shadow: 0 0 0 3px rgba(3, 29, 125, 0.12);
}

.ew-pay-method.is-active i {
  color: #031d7d;
}

</style>



// WEBPACK FOOTER //
// src/components/PaymentDetails.vue